module.exports = __webpack_public_path__ + "static/img/ewm.4352a20.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/ewm.png
// module id = ej+i
// module chunks = 1